import React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry.init';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import * as Sentry from '@sentry/react';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { setupSonnerDialogs } from './utils/sonnerDialogs';
import './index.css';

// Basic Sentry browser tracing is initialized in sentry.init.js
// Removed deprecated reactRouterV6Instrumentation usage causing import errors.

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (was cacheTime in v3)
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

setupSonnerDialogs();

// Wrap with Sentry.ErrorBoundary first (outer) and keep existing custom ErrorBoundary inside
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <AuthProvider>
          <Sentry.ErrorBoundary
            showDialog={false}
            fallback={({ error, componentStack, resetError }) => (
              <ErrorBoundary>
                {/* The custom ErrorBoundary already renders fallback; we just invoke it */}
                <div />
              </ErrorBoundary>
            )}
          >
            <App />
          </Sentry.ErrorBoundary>
          <Toaster position="top-right" richColors closeButton duration={4000} />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
